import React from "react";
import "../Styles/styles.css";

const Edict = () => {
  return (
    <section id="edict" className="edict">
      <div className="container" data-aos="fade-up">
        <SectionTitle title="EDICT" subtitle="UPGRADING OFFICE TO DIGITAL" />
        <Description />
        <Features />
        <Security />
        <ProductVersions />
        <AwardSection />
      </div>
    </section>
  );
};

const SectionTitle = ({ title, subtitle }) => (
  <div className="section-title">
    <h2>{title}</h2>
    <p>{subtitle}</p>
  </div>
);

const Description = () => (
  <div className="content">
    <p>
      Modern office work involves managing complex documents such as paper
      documents, scanned images, Word/Excel files, emails, drawings, video
      clippings, and more.
    </p>
    <p>
      These documents pass through various work centers with annotations,
      annexures, and get archived for retrieval when required. The Centralized
      Repository of Documents (CRD) eliminates duplicates and provides one-click
      access to complete information.
    </p>
  </div>
);

const Features = () => (
  <div className="features">
    <h5>Key Features</h5>
    <ul>
      <li>OCR, Form Recognition, and Barcode Reading</li>
      <li>Batch Scanning and Keyword Search</li>
      <li>Integration with other systems via Web Services</li>
    </ul>
  </div>
);

const Security = () => (
  <div className="security">
    <h5>Security Features</h5>
    <ul>
      <li>Access Control</li>
      <li>Encryption</li>
      <li>Audit Trail</li>
    </ul>
  </div>
);

const ProductVersions = () => (
  <div className="product-versions">
    <h5>Available Versions</h5>
    <p>EDICT is available in two versions:</p>
    <ul>
      <li>Standard</li>
      <li>Enterprise (Customizable)</li>
    </ul>
  </div>
);

const AwardSection = () => (
  <div className="award-section">
    <p>
      The product received the Best Office Automation Award from Microsoft in
      2003.
    </p>
    <a href="https://www.mmcspl.com/docs/EDICT%20-%20Brochure.pdf" className="btn btn-primary" download>
      Download EDICT Brochure
    </a>
  </div>
);

export default Edict;
